// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as OrderStatus from "../Order/OrderStatus.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CartGlobalDiscountView from "./CartGlobalDiscountView.res.js";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";

function CartOptionsView(props) {
  let dispatch = props.onRequestDispatch;
  let cart = props.cart;
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(CartGlobalDiscountView.make, {
          discount: cart.discounts[0],
          totalAmountExcludingGlobalDiscounts: cart.totalAmountExcludingGlobalDiscounts,
          onRequestDispatch: dispatch
        }),
        JsxRuntime.jsx(InputToggleSwitchField.make, {
          label: I18n.t("order_cart.cart_options.tax_application.toggle_switch.label"),
          alignToggleButtonToStart: true,
          required: false,
          value: cart.taxesFree,
          disabled: OrderStatus.has(props.statuses, "RECEIVED"),
          onChange: param => dispatch("TaxesFreeToggleRequested")
        })
      ],
      space: "large"
    })
  });
}

let make = React.memo(CartOptionsView, (oldProps, newProps) => {
  if (oldProps.cart === newProps.cart) {
    return oldProps.statuses === newProps.statuses;
  } else {
    return false;
  }
});

let Utils;

export {
  Utils,
  make,
}
/* make Not a pure module */
